// extracted by mini-css-extract-plugin
module.exports = {"userDataCard":"UserData_userDataCard__3RQOv"};